<main class="esf-main-content -has-transition -width-max">
  <div class="esf-container main-content--fit-screen">

    <h1 class="esf-heading esf-heading--page">
      <span class="esf-action-heading__text" i18n='@@customerMergerComponent.heading.customerMerger'>Customer Merger</span>
    </h1>
    <p i18n='@@customerMergerComponent.text.customerMerger'>
      In order to manually merge two customer data sets please paste both customer numbers into the fields below and follow the process.
    </p>

    <form [formGroup]="form">
      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [label]="flTranslations.i18nFirstCustomer"
             [id]="'firstCustomer'"
             [control]="form.get('firstCustomer')">
        </div>

        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [label]="flTranslations.i18nSecondCustomer"
             [id]="'secondCustomer'"
             [control]="form.get('secondCustomer')">
        </div>
      </div>

      <div style="max-width: 720px">
        <app-submit-row-buttons [submitButtonText]="buttonsTranslations.i18nNext"
                                [showCancel]="false"
                                [isFieldValid]="form.valid"
                                [spinnerName]="spinnerName"
                                (submitButton)="submitForm()">
        </app-submit-row-buttons>
      </div>

    </form>

  </div>
</main>
